import type { Action } from 'redux';
import type { Redirect } from '../../../../main/screens/ScreenLinkHubAdLinkCreator/steps/RedirectsStep/Redirects.types';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateDesktopRedirect = new ReduxAsyncAction<'UPDATE_DESKTOP_REDIRECT', Redirect, { desktopRedirect: Redirect }>(
  'UPDATE_DESKTOP_REDIRECT'
);

UpdateDesktopRedirect.registerRequest(async (desktopRedirect: Redirect) => {
  return { desktopRedirect };
});

export const UPDATE_DESKTOP_REDIRECT = UpdateDesktopRedirect.actionNamespaceConstants;
export const updateDesktopRedirect = UpdateDesktopRedirect.request;

export type UpdateDesktopRedirectResponseAction = Action<typeof UPDATE_DESKTOP_REDIRECT.response> & {
  data: { desktopRedirect: Redirect };
};
